export const errors = {
  not_found: {
    title: 'Page introuvable !',
    description: 'Cette page est introuvable',
    action: 'Retour à l\'accueil',
  },
}
